import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions"; // ✅ Add this


// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyC9QOR7mGi_nLzw82CkEqZbJpzGgc_jZ8g",
    authDomain: "cloudinvoice-c755c.firebaseapp.com",
    projectId: "cloudinvoice-c755c",
    storageBucket: "cloudinvoice-c755c.firebasestorage.app",
    messagingSenderId: "269723472855",
    appId: "1:269723472855:web:d3b7feb342a6e4a9af3192"
  };

// ✅ Create and export the app instance
const app = initializeApp(firebaseConfig);

// ✅ Export everything you use
export { app, getAuth, getFirestore, getStorage };
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app); // ✅ Export this too
